import clsx from 'clsx';

interface Props {
	children: React.ReactNode;
	className?: string;
}

export const CardContainer: React.FC<Props> = ({ className, children }) => {
	return (
		<div
			className={clsx(
				'bg-[#F4F4F9] rounded-[64px] md:p-[52px] pt-16 xl:pt-24 h-full w-full z-0',
				className
			)}
		>
			{children}
		</div>
	);
};
